<template>
	<div class="rules-info">
		<div>
			{{ highlightRulesText }}
			<ul>
				<li
					v-for="(rule, i) in highlightRules"
					:key="i"
				>
					"<a
						class="rule-link"
						:href="highlightRulesLink"
						target="_blank"
					>{{ rule.name }}</a>"
				</li>
			</ul>
		</div>
		<Icon
			v-tooltip="{
				content: highlightRulesInfo,
				classes: 'tooltip',
				container: $root.$el,
			}"
			icon-name="c-info"
			size="sm"
		/>
		<Icon
			class="exit"
			icon-name="e-remove"
			@click="() => $emit('close')"
		/>
	</div>
</template>

<script>
import laroute from '@laroute';

export default {
	name:  'HighlightRulesInfo',
	props: {
		highlightRules: {
			type:    Array,
			default: () => [],
		},
	},
	computed: {
		highlightRulesLink() {
			return laroute.route('manager.events.highlight_rules');
		},
		highlightRulesText() {
			return this.trans('one.tag_center_rule_active');
		},
		highlightRulesInfo() {
			return this.trans('one.tag_center_rule_info');
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.rules-info {
	display: flex;
	justify-content: space-between;
	padding: 16px 24px;
	color: var(--color-white);
	background: var(--color-green-petrol);

	.exit {
		cursor: pointer;
	}
}
</style>
